import { render, staticRenderFns } from "./LFooter.vue?vue&type=template&id=c0927964&"
import script from "./LFooter.vue?vue&type=script&lang=js&"
export * from "./LFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports